import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getShellConfig } from '@src/config/shell/config';

export const isMultiLoginTarget = shellLocalConfig.isMultiLoginTarget && getShellConfig().remoteConfig.isMultiLoginTarget;
